export const calcDidSceneSetChange = (
  currentPath: string,
  historyPath: string
): boolean => currentPath !== historyPath;
